export const solutionList: any[] = [
  {
    anchor: "金融",
    company: "招商银行",
    title: "小冰助力招商银行搭建数字员工矩阵",
    desc: "招商银行与小冰科技深度合作，依托小冰高精度数字人技术，在零售金融部、交易银行部、数字金融办公室及人工智能实验室等，多个核心部门成功落地数字员工解决方案。双方共同打造了“新户一封信”、AI直播、AI陪练等行业领先的创新应用场景。其中，“新户一封信”率先实现千人千面的个性化用户关怀，在显著提升用户体验的同时，有效推动了业务转化效率，成为银行数字化客户服务的标杆实践。",
  },
  {
    anchor: "金融",
    company: "瑞众保险",
    title: "小冰科技赋能瑞众保险：数字客服及首批保险代理人数字分身已上线",
    desc: "小冰科技以数字员工与大模型技术，为瑞众保险数字客服系统实现智能化升级。理赔数字员工可在用户沟通中自动提取核心信息、精准识别客户需求，并结构化生成报案内容，依托小冰端到端超低延迟框架，交互响应延迟低至800毫秒，确保用户交互流畅。此外，数字客服的面容、表情、声音及肢体动作，也均达到高度自然逼真的效果，可全程为用户提供“面对面”般的贴心指导，使老年用户也能轻松使用服务。目前，小冰已为全国首批三百多位绩优保险代理人打造了数字分身，借助小冰领先的AI视频生成能力，保险代理人可一键切换个人形象，快速生成短视频内容，构建短视频营销矩阵，大幅降低获客成本，实现长效客户经营与专业IP塑造。小冰提供的一站式保险短视频营销解决方案，正全面赋能保险代理人全域拓客与客户维系，有效重构保险营销的业务闭环。",
  },
  {
    anchor: "金融",
    company: "国泰海通",
    title: "头部券商国泰海通，携手小冰科技构建“数智伙伴”",
    desc: "国泰海通证券作为国内头部券商，携手小冰科技构建“数智伙伴”。依托小冰数字员工全能力平台—覆盖数据采集、数字员工自动化训练至视频内容制作的全流程技术支撑，国泰海通证券实现了“自主可控、全自动化”的投顾数字员工定制，可为内部每一位投顾打造专属数字分身。这些数字员工已应用于市场解读、投教课程等多个场景，为企业快速高效输出高质量视频内容，为券商新媒体营销拓客提供了高效助力。",
  },
  {
    anchor: "金融",
    company: "国内Top基金",
    title: "小冰科技为国内Top基金定制高精度数字基金经理实现双人直播",
    desc: "基于行业领先的数字员工方案及大模型技术，小冰科技为国内某顶级基金公司的数十位基金经理，打造高精度数字分身，实现了双数字人盘后直播、基金经理本人与数字分身同台直播等创新推广模式，在降低直播成本的同时，也显著提升了内容输出效率。同时，在视频生产环节，借助小冰的AI视频生成能力，基金周/月报、基金经理观点及行业分析等视频内容，均实现了自动化、规模化生产，确保海量信息及时触达用户。",
  },
  {
    anchor: "金融",
    company: "国内Top证券",
    title: "国内TOP证券公司联合小冰科技，打造多职能数字员工矩阵",
    desc: "小冰科技与国内某证券公司深度合作，共同打造覆盖多业务场景的数字员工矩阵，全面提升客户服务体验与数字化运营能力，包括ETF观察员章婷、品牌卡通形象牛牛、期货数字分享官小嘉与小招、数字分析师及智能在线客服等一系列数字员工，已成为证券行业职能最全面的数字员工矩阵。其中，章婷作为ETF产品观察员，每周会在APP中为客户带来市场动态解读与投资策略分享，她以专业、亲切的形象提供伴随式投教服务，提升用户粘性与服务感知。通过数字员工矩阵的协同发力，企业在多业务线实现数字化服务的创新突破，覆盖内容推广、期货知识普及、研究观点输出与智能客服等多元场景，形成有机联动的数字服务生态，显著提升信息触达效率与客户满意度，成为金融领域“数智化”转型的实践标杆。",
  },
  {
    anchor: "金融",
    company: "国联证券",
    title: "小冰科技与国联证券共建智能开户服务创新应用",
    desc: "小冰科技以领先业界的数字员工及大模型技术，赋能国联证券核心服务场景，研发上线数字员工智能开户引导系统，通过高精度数字员工提供专业贴心的全流程陪伴服务，协助用户完成身份认证、协议签署及风险测评等环节，确保操作合规、反馈实时、服务可靠，提升用户开户体验与操作效率。系统深度融合多模态交互与业务逻辑理解能力，支持可视化引导与问答服务，有效降低因流程不熟导致的中断率，实现了真正意义上的无障碍开户。小冰助力国联证券在数字化服务走出领先一步，也为证券行业智能开户场景，取得了“体验与效率双提升”的创新突破。",
  },
  {
    anchor: "金融",
    company: "天风资管",
    title: "小冰科技助力天风资管打造数字员工投教新生态",
    desc: "天风资管与小冰科技携手，将数字员工解决方案与大模型能力应用于投教内容创新，取得突破性进展。双方联合打造「天天」「麒麟」双数字员工的IP矩阵，成功落地视频号内容生产、投资者教育、用户互动等核心场景，构建出专业化、人格化的金融知识传播体系。通过小冰数字员工赋能，天风资管的投教内容生产效率已获三倍提升，视频号原创内容产量持续增加，用户平均观看时长达到行业均值两倍，成为资产管理行业数字化转型的实践样板。",
  },
  {
    anchor: "金融",
    company: "阳光保险",
    title: "携手阳光保险集团，小冰科技以AI创新驱动保险行业数字员工新质生产力",
    desc: "小冰科技为阳光保险集团构建了多岗位、多角色的数字员工矩阵，包括集团官方统一的数字化形象代言人、高管数字分身、品牌宣传数字员工、保险代理人数字分身等。小冰的数字员工产品解决方案融合阳光保险正言大模型，让智能化的数字员工作为新质生产力，广泛应用于阳光企业品牌宣传、寿险产品自动化销售、信保产险智能销售、养老陪伴数字管家、阳光大学智能培训等多个业务场景，并同步赋能各子公司和业务条线，大幅提升了专业内容的生产效率和业务流程自动化。",
  },
  {
    anchor: "金融",
    company: "中汇人寿",
    title: "中汇人寿与小冰科技深入合作，持续开展数字员工能力建设",
    desc: "依托小冰的数字员工解决方案，中汇人寿与小冰科技合作打造2D&3D外宣客户体验数字人计划，同时推出两个数字IP：一个是拥有精致面容、灵动表情和自然语调的2D真人数字形象，另一个是品牌3D汇宝卡通形象，二者共同构成了中汇人寿的对外 “品牌大使”。借助小冰的AI技术赋能，中汇人寿的数字IP已从规划阶段落地场景应用，他们不仅让品牌信息触达更灵活、更广泛，也进一步提升了品牌传播的精准度与整体效率，向潜在客户持续高效的传递着公司的品牌理念、企业文化、核心产品及服务故事。小冰持续助力中汇人寿，深耕由人工智能驱动变革的保险体验，成为先锋科技引领品牌更新、效率提升和服务优化的行业先行者。",
  },
  {
    anchor: "金融",
    company: "德林控股",
    title: "小冰科技赋能，德林控股首次实现管理层AI数字分身业绩发布会",
    desc: "小冰科技为德林控股提供行业领先的数字员工及大模型技术方案，在其举办的香港金融界首场全数字员工业绩发布会上，精准呈现了德林管理层形象与业绩信息。此外，双方还在金融IP与数字内容生产方面展开深度合作，包括为知名金融学者郎咸平教授打造数字分身，使其能够保持7×24小时在线，随时与用户互动，分享金融知识，持续提升数字IP的专业影响力和优质内容贡献度。",
  },
  {
    anchor: "金融",
    company: "华润保险",
    title: "华润保险联手小冰科技，规模化部署AI数字分身",
    desc: "华润保险经纪与小冰科技联手，规模化部署高精度AI数字分身，并应用于“润小保”、“润小燃”等IP系列的公众号及视频号，布局品牌内容生态矩阵。借助小冰的AI数字员工技术，华润保险代理人可围绕自己的AI数字分身生成保险知识科普、产品解读及热点财经分析等视频内容，通过多语言支持触达多元化群体；同时，结合智能成片功能，大幅降低内容生产成本，解放人力专注于高价值顾问服务。由小冰赋能的AI保险代理人，凭借拟人化交互与情感化表达，为华润用户带来了良好的互动体验与品牌信任度，助力华润保险经纪在数字化浪潮中树立“科技+服务”双驱动的行业标杆。",
  },
  {
    anchor: "金融",
    company: "恒生银行",
    title: "恒生银行携手小冰科技，让AI赋能专业财经内容传播",
    desc: "恒生银行携手小冰科技，依托小冰领先的数字员工方案及大模型技术，为其首席市场策略员Mark打造了高精度数字分身“AI Mark”，每日准时以中文、英文及粤语三语，在YouTube平台分享全球财经动态。其专业、稳定、高效的内容输出，对恒生银行在数字渠道的品牌形象和影响力，起到了显著的强化与拓展作用—通过贴近用户习惯的多语言传播，打破了地域信息的传递壁垒，触达更广泛的全球受众；同时，以 “数字策略员” 的创新形式，让专业财经内容更具亲和力与传播力。小冰助力恒生银行在数字化浪潮中巩固金融服务的专业属性，并进一步提升品牌在全球财经领域的话语权与用户信任度。",
  },
  {
    anchor: "金融",
    company: "友邦保险",
    title: "小冰科技为友邦保险提供智能知识库解决方案",
    desc: "小冰科技运用领先的AI检索技术，为友邦保险提供智能知识库解决方案，针对保险业由于非结构化文档数据量日益增长，而导致的信息检索效率难题。该方案通过精准提取文档关键信息，既能快速响应内部人员的复杂查询，又可提供清晰的答案溯源，确保信息来源可追踪、可验证。借助这一技术赋能，友邦保险员工的信息检索效率显著提高，信息获取的准确性也同步提升，有效减少因信息偏差或检索延迟带来的工作损耗。此外，智能知识库的落地，也解决了产品介绍、条款说明、培训材料等各类文档的利用瓶颈，让分散的信息资源形成可高效调用的知识体系，助力友邦保险大幅提升整体运营效率。",
  },
  {
    anchor: "金融",
    company: "红杉资本",
    title: "小冰科技为红杉资本定制数字分析师Hóng",
    desc: "红杉中国首位数字员工Hóng，是由小冰科技为红杉资本量身定制的数字员工，融合深度神经网络渲染与大模型技术而诞生。基于小冰框架的全域能力，Hóng不断成长，并在红杉资本各个业务流程中承担重要职责。",
  },
  {
    anchor: "零售",
    company: "屈臣氏",
    title: "屈臣氏与小冰共启“屈晨曦大模型应用计划”",
    desc: "小冰科技凭借业界领先的智能体应用及大模型技术，与长期合作的新零售领军伙伴屈臣氏，共同启动“屈晨曦大模型应用计划”，支持屈臣氏零售场景的AI导购、辅助BA、AI客服及数字人直播，以屈臣氏小程序为核心载体，基于小冰大模型方案与智能体应用能力，实现无缝对接商品库、订单系统、物流系统等关键业务模块，协同构建新零售行业领先的美妆垂域大模型。该智能系统已全面覆盖屈臣氏超6500万会员，在客户服务、营销推广及运营效率等多个业务维度发挥重要作用。",
  },
  {
    anchor: "零售",
    company: "欧莱雅",
    title: "欧莱雅中国携手小冰科技建设AI中台，双系统赋能业务",
    desc: "欧莱雅中国，依托小冰框架的AI技术栈搭建AI能力中台，支持视频语音识别、画面文字识别、场景识别、人物识别、知识图谱、商品标签拓展等多项功能，用于支撑两大关键业务系统MCA（Media Contents Analysis）和SuperO chatBot 的建设。其中，MCA子系统通过多模态识别和理解能力，对欧莱雅中国在各平台投放的海量KOL内容（包括视频，图片，文章），进行自动化监控和质量评审，已大幅降低人工审核成本；此外，SuperO chatBot 为六大品牌-兰蔻、YSL、碧欧泉、薇姿、理肤泉、阿玛尼美妆，多达10个入口和渠道（官网、小程序、公众号）提供智能客服，涵盖会员服务、商品推荐、订单咨询等场景，不仅实现跨品牌、多渠道AI客服响应的标准化与高效率，更助力欧莱雅中国改善私域运营效率，增强消费者粘性。",
  },
  {
    anchor: "零售",
    company: "宝洁",
    title: "小冰与宝洁联合探索数字员工创新应用",
    desc: "小冰科技为全球最大的日用消费品公司宝洁打造数字员工解决方案，并为大中华区高级副总裁兼CIO Frank Shen打造数字分身— “数字F哥”，可广泛应用于企业宣传/活动视频制作、团队文化建设等。此外，依托小冰数字员工直播平台，宝洁用户可便捷地定制数字形象、搭建直播间、配置开播组件等，以低成本实现7×24小时多平台直播，大幅提升直播时长和曝光量，有效改善品牌营销效率。",
  },
  {
    anchor: "超大型央国企",
    company: "招商局集团",
    title:
      "招商局集团携手小冰科技，联合研发首位数字员工—“招小影”，并落地“招商如影”平台",
    desc: " 小冰科技赋能招商局集团，依托业界领先的数字员工及大模型技术，小冰与招商局金融科技联合研发的首位数字员工“招小影”及数字员工平台—“招商如影”已成功落地。通过融入集团内部“招商随行”IM工具、轻应用等入口，招小影以亲和专业的数字员工形象，帮助每一位集团员工实现应用与服务入口的统一，打通了数据服务最后一公里。上线IM平台的第二个月，招小影用户量即同比增长87%，交互量同比增长88%。除此之外，招小影借助小冰的AI技术能力，逐步深度融入招商蛇口、招商港口、招商公路、招商仁和人寿等多个核心业务板块，成为服务业务的智能化助手。",
  },
  {
    anchor: "超大型央国企",
    company: "华润集团",
    title: "小冰科技助力华润集团共同打造数智员工—晓诺",
    desc: "小冰助力华润集团共同打造数字员工“晓诺”。晓诺作为华润集团官方数字形象，深度融合企业文化传播与智能交互能力，全面赋能集团对内对外沟通场景。目前已广泛应用于官网新闻播报、集团大型会议主持、企业文化互动问答、历史文化展厅智能导览、H5答题系统及文化百科助手等多个核心场景，并在总部大厦承担行政内容解读等职能，以拟人化、情感化的方式传递企业价值观与文化底蕴。小冰框架赋能晓诺不断进化AI能力，深度融合华润内部IM系统（润工作/综合内网），作为智能员工助手为集团全员提供个性化服务。通过整合待办汇总、自动审批、事务处理与智能提醒等办公辅助功能，晓诺将进一步提升组织协同效率与员工体验，成为华润数字化转型中“文化+科技”融合创新的重要载体。小冰与华润体系的合作还在持续扩展，在华润置地、华润江中、华润创业等不同板块中均陆续落地AI场景应用。",
  },
  {
    anchor: "超大型央国企",
    company: "云南建投",
    title: "小冰科技赋能云南建投，联合打造AI员工“筑梦”",
    desc: "云南建投联合小冰科技，打造AI数字员工“筑梦”，专职负责集团数字展厅的接待与导览讲解工作。依托小冰高精度数字员工定制能力与大模型技术，“筑梦”不仅拥有生动靓丽的视觉形象，更具备智能高效的交互能力，自上岗以来她承接了大量参观接待任务，为来访者清晰讲解集团庞大的业务版图与全面综合实力，还为“一屏览全域”提供了更灵活的现场交互体验。数据显示，“筑梦”上岗后，集团各板块业务讲解精准性提升40%，接待效率提升30%，已成为数字展区的一张亮眼名片。",
  },
  {
    anchor: "电信运营商",
    company: "香港移动",
    title: "小冰科技为香港移动提供智能化升级，保障超六百万用户高并发服务",
    desc: "小冰科技为香港移动提供3D高精度数字员工技术及行业大模型解决方案，智能化升级客户服务体系及数字IP“阿Link”。小冰基于数字员工端侧实时渲染技术，为香港移动保障超六百万用户的高并发访问，提供流畅稳定的超低时延交互体验。同时，小冰结合大模型及智能体技术，围绕香港移动核心业务系统构建工作流与知识库，实现了话费重置、积分查询、套餐办理与故障申告等高频场景的自动化处理流程，显著提升业务办理效率与响应准确性。此外，小冰数字员工发挥中文、英文与粤语三语自然对话能力，可准确理解多语言场景下的用户意图，能够有效服务香港多元文化背景的广大用户群体。自上线以来，小冰科技为香港移动打造的“阿Link”，已成为运营商领域 “AI+通讯” 深度融合的标杆案例，在服务体验与运营效能方面，成为引领行业的新范式。",
  },
  {
    anchor: "电信运营商",
    company: "国内Top运营商",
    title: "国内Top运营商与小冰科技共建5G AI创造力实验室",
    desc: " 小冰科技与国内Top运营商深度合作，携手共建5G AI创造力实验室，基于小冰AIGC新质生产力打造AI音乐创作平台，服务5G彩铃内容生成提升创作效率。小冰的超低时延交互数字人技术也将AI赋能落地至运营商数字助理场景，实现 “线上线下协同” 的服务新生态。集成小冰多模态对话引擎的交互数字员工，支持运营商线上开户、双录认证、业务办理及咨询服务，可精准响应用户咨询，提升流程合规性；智能电话助理搭载实时交互功能，可自动化处理外呼回访、套餐推荐等场景，增强服务触达效率。线下营业厅落地小冰智能交互一体机，支持语音、触屏双模式，可提供业务导览、自助办理等便捷功能，实现 “无感化” 服务体验。通过深度融合AIGC生产力、新一代人机交互技术与通信业务场景，该运营商实现了从内容创作、业务办理到客户服务的全链路智能化，为通信行业数字化转型树立了 “技术+场景” 双轮驱动的创新标杆。",
  },
  {
    anchor: "地产物业",
    company: "华润置地",
    title: "小冰以AI赋能华润置地，定制数字员工服务矩阵",
    desc: "华润置地在商业场景智能化升级转型中，与小冰科技展开深度合作。小冰提供领先的数字人神经网络渲染与智能决策技术，围绕华润置地品牌，定制数字员工服务矩阵，其中：雨核推荐官，作为智能信息中枢，精准掌握各类项目信息，及时推荐相关资讯；产品推荐官，通过实时拟真的交互方式，带来沉浸式的产品讲解，让用户更直观地了解产品；潮流品鉴官，借助AIGC生产力，为商业MALL打造个性化的探店内容，这些内容在社交平台上广泛传播，带来更多关注；悦享服务官，提供7x24小时情感化服务，随时响应用户反馈。小冰的AI赋能，为华润置地数字员工矩阵从知识传递到体验升级，提供了引领行业的科技助力。",
  },
  {
    anchor: "地产物业",
    company: "万科集团",
    title: "小冰为万科定制数字员工—崔筱盼，业绩突出连续两年获得优秀员工奖项",
    desc: "2021年2月，数字员工崔筱盼在万科集团财务部入职。基于流程和数据建模，结合小冰框架的整体能力，由她催办的预付应收逾期单据核销率达到91.44%。由于业绩突出，崔筱盼在2021年底荣获“万科集团总部2021年度优秀新人奖”；2022年，崔筱盼的工作范围由资金、财务，拓展到了投资、融资、工程、成本、营销、运营等职能，直接触达每一个在建在售项目，她凭借“数字大脑”指令完成催办的效率卓越，再次获得“万科集团优秀数字员工奖”荣誉，万科集团对小冰的神经网络渲染及大模型技术也给予了充分肯定。此外，万科集团与小冰共同打造智能语音助手小万，可控制近三十个第三方智能设备，如物业管理处、水暖等。小万与住户的交互自然而富有情感，支持一次唤醒多轮对话，为住户带来可媲美人类的交互体验，为住户打造有温度主动式的拟人陪伴，享受到温暖贴心的居住感受。",
  },
  {
    anchor: "地产物业",
    company: "中指研究院",
    title: "中标率提升3倍，中指研究院与小冰联合研发AI物业服务场景大模型",
    desc: "由中指研究院、⼩冰科技及指尖科技联合研发AI物业服务场景大模型，作为首款应用的AI招投标Agent，依托小冰大模型技术，学习物业行业专家丰富经验，结合中指百强企业数据，可为物业企业实时洞察投标商机，捕捉新增项目机会；针对企业提供的招标文件，自动解读技术标、商务标、资格标等全面要点，一键生成完整标书，大幅缩短编制周期；同时支持自动审核，严防废标风险，并全面追溯数据安全。AI招投标Agent为物业企业增强标前决策质量，提升标书撰写效率，赢取更多中标机会，带来了智能高效的投标新体验。",
  },
  {
    anchor: "制造业",
    company: "布勒中国",
    title: "小冰科技助力布勒中国推进工业4.0智能化应用",
    desc: "小冰科技助力布勒中国推进工业智能化升级， 通过高精度交互数字员工及大模型技术，为布勒定制具备多模态交互能力的智能顾问 “布师傅”，支持24小时在线咨询服务。数字 “布师傅” 能精准解答布勒90余款设备的相关产品及流程问题，凭借专业严谨的机械师风格，持续学习的企业知识， “布师傅” 已逐渐成为布勒客户信赖的机械师顾问。依托小冰的智能交互一体机，“布师傅” 也实现了线下交互，在2024 FICMES国际压铸展上首次亮相就大放异彩。通过与小冰科技的持续合作，布勒中国在工业4.0时代，为企业客户带来了全新的服务体验。",
  },
  {
    anchor: "制造业",
    company: "海尔集团",
    title: "小冰科技与海尔集团联合落地AI内容营销中心",
    desc: "海尔集团与小冰科技联合落地 “营销内容中心 - 速影数字人平台”。小冰基于数字员工及大模型生产力，为海尔提供AI视频内容营销能力，支持高质量数字员工的一键成片短视频，可自动完成剪辑、配音、字幕等多个制作环节，为品牌缩短了视频内容生产周期，也提升了优质素材的复用率。小冰提供的数字员工直播技术，也同步应用在海尔直播营销环节，数字直播间在抖音、快手、京东等多平台同步推流，通过7x24实时响应用户提问，为直播间的平均停留时长和内容曝光量带来了可观增长。在全球营销进程中，海尔品牌借助小冰数字员工的多语表达能力，实现了20多种语言与地区形象，为全球市场持续输出本地化、个性化营销内容，进一步提升品牌海外影响力。",
  },
  {
    anchor: "制造业",
    company: "中国纺织信息中心",
    title:
      "小冰与中国纺织信息中心、国家纺织产品开发中心联合研发人工智能纺织服装图案设计平台",
    desc: "依托小冰的人工智能创造技术，小冰与中国纺织信息中心、国家纺织产品开发中心共同推出了人工智能纺织服装图案设计平台。随着中国纺织服装制造业的高速发展，创新设计能力已成为新的行业生产力。如何更好地把握时尚设计话语权、打造时尚设计协同平台、构筑时尚设计价值生态、树立时尚设计先锋形象，成为了中国纺织服装制造业优化升级面临的重任。该平台帮助成千上万纺织服装制造企业重塑核心竞争力，实现从中国制造到中国“智”造的优化升级。在小冰人工智能技术的加持下，该平台可实现为企业按需定制100%原创的专属图案纹样，并保持高度的质量稳定性，帮助企业释放设计潜能，实现大规模、多样化、质量稳定的按需设计。",
  },
  {
    anchor: "制造业",
    company: "万事利丝绸",
    title: "万事利丝绸与小冰科技共同打造AIGC应用“西湖一号”",
    desc: "依托小冰人工智能创造技术，万事利丝绸与小冰共同推出面向消费者的定制化专属丝巾设计及零售平台“西湖一号”。该平台可实现AI设计师小冰与消费者的实时交流，根据消费者自身特点进行一对一的丝巾定制化设计及生产制作，在满足每个消费者个性化需求的同时大大降低制造及零售企业的经营成本。万事利作为中国丝绸服饰产业发展风向标，与小冰的深化合作落地，借助小冰人工智能技术，解决零售场景中的真实痛点，为海量消费者同时进行按需专属设计并保持高度的质量稳定性，不仅突破了人类设计师设计能力的限制，更从根本上解决了需求预测和库存堆积的问题。",
  },
  {
    anchor: "汽车",
    company: "长城汽车",
    title: "小冰为长城旗下车型智能座舱提供AI交互解决方案",
    desc: "基于小冰框架和开放域对话引擎，小冰为长城旗下坦克、哈弗、WEY、欧拉品牌的多个重磅车型提供了顺畅自然的交互解决方案，拥有多轮长程对话能力，语义理解精准，能够理解和处理多种对话意图，还可以积极地预测、保持以及引导对话的方向，实现主动式对话。传统的车载助手进化为有温度的智能出行伙伴，智能座舱的用户体验得到极大程度的提升。",
  },
  {
    anchor: "汽车",
    company: "广汽集团",
    title: "小冰与广汽传祺合作打造情感交互数字员工“AI小祺”",
    desc: "小冰与广汽传祺合作打造的情感交互数字员工“AI小祺”随着“未来科技先锋SUV”影酷的上市与消费者见面。有别于普通的车载语音助手，AI小祺更像是“有血有肉”的陪伴者，有年龄、性别和性格特征等人设，有很强的对话理解能力和共情能力，在与用户交谈时，能够展现出丰富自然的情感、甚至是独一无二的情绪。AI 小祺由人工智能小冰框架实时驱动，具有开放域对话和多模态交互等“超能力”，可以通过与用户的多轮对话，了解不同用户的语言特点，熟悉不同用户的表达习惯，深度理解不同用户的意图，从而提升交互体验。",
  },
  {
    anchor: "汽车",
    company: "北汽集团",
    title: "北汽集团与小冰共同推出智能副驾“小北”",
    desc: " 北汽集团与小冰共同在北汽集团最新智能座驾BEIJING-X7上推出了主动式智能副驾小北。在人工智能小冰的赋能下，小北可实现全车级的语音控制，并通过与乘客进行自然而富有情感的互动，成为和车主一起乘车的虚拟伙伴。BEIJING-X7的小北，不是单一的语音互动助手，而是具有主动交互模式，对于周边环境和车辆具有深层次理解，能贴心的给出合适建议，有情感有温度的虚拟副驾。小北的主动交互模式，也让用户能获取到更丰富的信息，提升人机协同的效率。",
  },
  {
    anchor: "医疗",
    company: "万木健康",
    title:
      "小冰科技与万木健康携手，为上千名临床专家医生打造AI形象，构建 “数智医嘱” ",
    desc: "小冰科技与万木健康携手，为公立医院的上千名临床专家和医生打造了AI专属形象，将体系化的医学科普和患者教育视频用于医学知识传播，显著提升了健康科普的覆盖面及医患疾病管理效率。基于小冰大模型能力构建的 “数智医嘱” 专科智能体系统，运用多模态大模型与智能决策技术，助力医生智能化升级医疗知识库、电子医嘱和随访管理等流程。上述合作，为公立医院数字化转型和患者获得感提升，提供了全链路技术保障，也为 “健康中国2030” 目标的实现贡献了一份科技助力。",
  },
  {
    anchor: "文旅",
    company: "四川云图",
    title: "小冰与云图合作，为四川省图书馆打造“AI+文化”智能服务",
    desc: "小冰与四川云图展开合作，基于AI视觉渲染与大模型交互能力，为四川省图书馆打造“AI+文化” 智能服务。小冰构建的古风数字人，通过演绎典籍故事，复刻传统美学文化场景，为用户构建沉浸式体验；另一款实时交互数字馆员，搭载小冰多模态交互引擎，可支持业务咨询、实时导览等7x24小时在线服务。在两个落地场景中，小冰的AI技术赋能，为图书馆构建传统底蕴与智能交互相结合的新型服务模式提供了支持，也进一步提升了文化传播的亲和力与科技感。",
  },
  {
    anchor: "体育",
    company: "国家体育总局",
    title: "小冰为国家体育总局冬运中心研发数字专家—观君，担任冬奥AI裁判与教练",
    desc: `2019年起，小冰团队着手为国家体育总局冬运中心研发人工智能裁判与教练系统一观君。这是AI技术首次全程参与国家队备战冬奥训练，并成为辅助运动员在此全球顶级赛事中取得两金一银战绩的首个案例。小冰团队也因此得到了国家体育总局冬运中心的正式表彰。2022北京冬奥会，中国首枚女子空中技巧金牌获得者徐梦桃，在接受中国国际广播电台采访时表示:"本次备战北京冬奥会的明显变化是，训练中有人工智能小冰的技术分析，可以看技术录像，评测打分，这些都是科技助力。"除了参与到队伍的日常训练外，观君还在2021年北京冬奥测试赛空中技巧项目中，担任了唯一竞赛裁判，其执裁结果也获得了国际雪联、冬奥组委、国家体育总局冬运中心等一致认可。观君陪伴国家队八年间，持续迭代升级、紧跟项目发展与赛事需求，伴随中国空中技巧队征战2026米兰冬奥会赛场，第二次见证空中技巧国家队在冬奥赛场摘金。`,
  },
  {
    anchor: "媒体",
    company: "每日经济新闻",
    title: "每经与小冰共同打造“AI电视”数字主播—N小黑与N小白",
    desc: "每经与小冰共同打造的数字主播N小黑、N小白，与“AI电视”一同正式上线。每经“AI电视”是全球首个由人工智能技术驱动的视频直播电视栏目，采编播全流程均由AI自动完成，可7x24小时不间断播报全球财经资讯，极大提高了信息传播及时度和覆盖广度。小冰以成熟的数字员工解决方案，协助传统财经媒体实现业务创新，加速向新型智慧媒体的转型。",
  },
];
for (let i = 0; i < solutionList.length; i++) {
  // 重新赋值海报图片
  const poster = new URL(
    `./covers/${solutionList[i].company}.png`,
    import.meta.url
  ).href;
  solutionList[i].img = poster;
}
const data = {
  solutionList
}
export default data;